import React from 'react';
import HeroBookDemoCta from './HeroBookDemoCta';
import HeroBrandLogo from './HeroBrandLogo';
import HeroTypewriterTitle from './HeroTypewriterTitle';
import '../hero/HeroSection.css';
import './CROHeroSection.css';

const CROHeroSection: React.FC = () => (
  <section className="hero">
    <div className="hero-bg" aria-hidden="true">
      <img src="/images/hero_lummo.png" alt="" loading="eager" className="hero-bg-img" />
      <div className="hero-vignette" />
    </div>
    <div className="hero-container">
      <div className="hero-inner">
        <HeroTypewriterTitle text="CROs: Superpowering Clinical Trial Execution" />
        <p className="hero-subtitle">From protocol design to patient recruitment and progress in real time, Lummo accelerates trial execution while ensuring regulatory compliance across LATAM markets.</p>
        <HeroBookDemoCta />
        <HeroBrandLogo />
      </div>
    </div>
    <div className="scroll-indicator" aria-hidden="true">
      <span className="scroll-dot" />
    </div>
  </section>
);
export default CROHeroSection;
